var element = document.getElementById("paypalpay");
var button = document.getElementById("paypal-button-container");

export const buy = async (id, name, price) => {
  element.style.display = "block";
  button.innerHTML = "";
  window.paypal.Buttons({
    createOrder: function (data, actions) {
      return actions.order.create({
        intent: "CAPTURE",
        purchase_units: [{
          custom_id: id,
          description: name,
          amount: {
            value: price
          },
        }],
        application_context: {
          shipping_preference: 'NO_SHIPPING'
        }
      });
    },
    onApprove: function (data, actions) {
      return actions.order.capture().then(function (details) {
       // window.unity.response(details.purchase_units[0].payments.captures[0].id)
        element.style.display = "none";
      });
    }
  }).render('#paypal-button-container');
}